<template>
  <div class="select_image" :class="imageClass">
    <img :src="setImagePath()" v-on:error="imageError" alt="">
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import Config from '@/config/config'
import ProductFunction from '@/model/n-selection/selectProducts'


export default {
  props: ['productId', 'genreId', 'imageClass'],
  methods: {
    setImagePath() {
      return Config.APIURL + this.getImageData();
    },
    imageError(e) {
      e.target.src = Config.APIURL + this.getNoImagePath();
    },
    getImageData() {
      const indexList = ProductFunction.productIndex(this.productsList, this.productId, this.genreId);
      if(indexList == undefined) return;
      return this.productsList[indexList.genreIdIndex].itemList[indexList.productIdIndex].product.imagePath;
    },
    getNoImagePath() {
      const indexList = ProductFunction.productIndex(this.productsList, this.productId, this.genreId);
      if(indexList == undefined) return;
      return this.productsList[indexList.genreIdIndex].itemList[indexList.productIdIndex].product.noImagePath;
    }
  },
  computed: mapGetters(
    'nselection', ['productsList'],
  ),
}
</script>

<style lang="css" scoped>
.item_image {
  margin: auto;
  width: 90%;
}
</style>



// WEBPACK FOOTER //
// src/components/n-selection/parts/ProductImage.vue